module.exports = __webpack_public_path__ + "static/media/pic2@2x.e71e6294.png";